import { ItemfluxObjectType } from '@/enum/ItemfluxObjectType'
import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloItemflux extends AloBase {    
    flxId:number
    itfDirection:number
    itfTypObj:ItemfluxObjectType
    itfFid:number
    itfMkpScope:number|null
}

export const getDefaultAloItemflux = ():AloItemflux => {
    return {
        ...getDefaultAloBase(),
        flxId:0,
        itfDirection:0,
        itfTypObj:ItemfluxObjectType.Univers,
        itfFid:0,
        itfMkpScope:null
    }
}

export const cleanAloItemflux = (itemFlux:AloItemflux) => {
    if(!itemFlux) return
    if(!itemFlux.id) delete itemFlux.id
    if(!itemFlux.itfFid) delete itemFlux.itfFid
}